import { QueryClient } from '@tanstack/react-query'
import {
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_DEFAULT_RETRY,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: CACHE_STALE_TIME,
      gcTime: CACHE_GC_TIME,
      retry: QUERY_DEFAULT_RETRY,
      networkMode: QUERY_NETWORK_MODE,
      refetchOnWindowFocus: false,
    },
  },
})
